
import { mapGetters } from "vuex"
import { mdiSend } from "@mdi/js"
export default {
    data() {
        return {
            mdiSend: mdiSend,
            popular_cities: [{}, {}, {}],
        }
    },
    computed: {
        ...mapGetters("search", {
            history: "history",
            route: "route",
            messen: "jobFairs",
        }),
        activeFairs() {
            return this.messen.filter((fair) => {
                return fair.start_at <= new Date() && fair.end_at >= new Date()
            })
        },
    },
    mounted() {
        this.$store.dispatch("search/fetchFairs")
        this.$axios
            .get("/api/search/popular_cities")
            .then((result) => {
                this.popular_cities = result.data.items
            })
            .catch((e) => {
                console.error("Error @ Search loading popular cities: ", e)
            })
    },
    methods: {
        navigateToHistoryElement(history) {
            this.dialog = false
            this.$router.push(history.route)
        },
        addDays(date, days) {
            const copy = new Date(Number(date))
            copy.setDate(date.getDate() + days)
            return copy
        },
        jobFairLogo(fair) {
            if (fair.logo) {
                return this.$getImage({
                    image: fair.logo,
                    preferedSize: "3",
                }).src
            } else {
                return require("@/assets/images/fair/logo-inverted.png")
            }
        },
    },
}
